import { Button } from '@/src/common/components/Button'
import { Dialog, YStack } from 'tamagui'
import { RatingBar } from '../RatingBar'
import { SurveysE2E } from '../../e2e'
import { useState } from 'react'

export const OverallRating = ({ onSubmit }: { onSubmit: (rating: number) => void }) => {
  const [overallRating, setOverallRating] = useState(0)

  return (
    <>
      <Dialog.Title key="title" text="center" fontSize="$6" lineHeight="$10">
        How would you rate Mesa?
      </Dialog.Title>
      <YStack gap="$4">
        <RatingBar rating={overallRating} onRatingChange={setOverallRating} />
        <Button
          disabled={overallRating === 0}
          title="Submit"
          onPress={() => onSubmit(overallRating)}
          testID={SurveysE2E.Ids.Press.SubmitOverallRating}
        />
      </YStack>
    </>
  )
}
